<template>
    <div>
        <keen-basic-contact-input
            ref="contactInput"
            v-model="contact"
            primary-telephone-placeholder="Telephone (Optional)"
            email-placeholder="Email (Optional)"
            optional-email
            optional-telephone
            :disabled="isSaving"
            label="Customer"
            placeholder="Full Name"
            icon=""
        />

        <div style="background: rgb(255, 252, 220); padding: 1.5rem;">
            <quill-message-field
                :value="content"
                @input="c => { this.content = c }"
                :disabled="isSaving"
            />
        </div>

        <div class="row" style="margin-top: 1rem;">
            <div class="col">
                <message-box-dropdown-selector
                    v-model="messageBox"
                    :disabled="isSaving"
                />
            </div>
            <div class="col text-right">
                <ui-button
                    icon="check"
                    color="primary"
                    :loading="isSaving"
                    @click="save"
                >Save</ui-button>
            </div>
        </div>

        <similar-contact-modal
            ref="duplicates"
        />

    </div>
</template>

<script>
    import MessageBoxDropdownSelector from "./MessageBoxDropdownSelector";
    import QuillMessageField from "./QuillMessageField";
    import {ConversationResource} from "../../classes/Api/Inbox";
    import SimilarContactModal from "../elements/SimilarContactModal.vue";

    export default {
        components: {SimilarContactModal, QuillMessageField, MessageBoxDropdownSelector },
        props: {
            medium: {
                type: String,
                default: 'phone'
            },
           defaultMessageBox: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        created() {
            this.reset()
        },
        mounted() {
            this.reset()
        },
        data() {
          return {
              contact: {},
              subject: '',
              content: '',
              messageBox: {},
              isSaving: false
          }
        },
        methods: {
            reset() {
                this.contact = {}
                this.subject = ''
                this.content = ''
                this.messageBox = this.defaultMessageBox
                this.isSaving = false
                if (this.$refs.contactInput) {
                    this.$refs.contactInput.reset()
                }
            },
            save() {

                this.isSaving = true

                this.$refs.duplicates.check(this.contact)
                    .then(contact => {
                        ConversationResource.log(
                            contact, this.subject, this.content, this.messageBox.id
                        ).then(r => {
                            this.$emit('saved')
                        }).catch(handleApiError)
                            .finally(() => {
                                this.$store.dispatch('user/badges/update')
                                this.isSaving = false
                            })
                    }).finally(() => { this.isSaving = false })
            }
        }
    }
</script>

<style scoped>

</style>